import {
    WB_HierarchyIntelligentKeyRow,
    WB_HierarchyLevelRow,
    WB_HierarchyPeriodRow,
    WB_HierarchyRow
} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {
    esWB_Customer,
    esWB_Hierarchy, esWB_Hierarchy_Entity_Generation, esWB_Hierarchy_Intelligent_Key,
    esWB_Hierarchy_Level,
    esWB_Hierarchy_Period,
    esWB_Hierarchy_SalesArea, esWB_Period, esWB_Product_Group, esWB_User_Group
} from "../PA.Core/PAdbSchema";
import * as _ from "lodash"
import {IHierarchyNodeProvider, IHierarchyStructure, INode} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";

// API for reading, changing the hierarchy harness
const workerCountMin = 4
const workerCountMax = 20
const workerCountDefault = 10

const vUI_Hierarchy_DeleteNodes_schema = PASearch.createSimpleSchema([
    'ENTITY_DIMENSION',
    'NODE_MAPPER',
    'NODE_ID_UI',
    'NODE_SET_ID',
    'HIER_NODE_IND',
    'DELETED_IND'
],[
    'WB_HIERARCHY_ID',
    'TARGET_WB_ID',
    'NODE_WB_ID'
])
interface  IHierarchyDeleteNodesRow {
    WB_HIERARCHY_ID: number
    ENTITY_DIMENSION: string
    TARGET_WB_ID: number
    NODE_WB_ID: number
    NODE_MAPPER: string
    NODE_ID_UI: string
    NODE_SET_ID: string
    HIER_NODE_IND: string
    DELETED_IND: string
}

export class HierarchyHarness
{
    private _hierarchyRow: WB_HierarchyRow
    // add attributes as needed.
    async Save(): Promise<void> {

    }

    constructor(harness: WB_HierarchyRow) {
        this._hierarchyRow = harness
    }

    get WB_HierarchyRow(): WB_HierarchyRow {
        return this._hierarchyRow
    }

    get ActivePeriod():WB_HierarchyPeriodRow{
        return _.first(_.filter(this.WB_HierarchyRow.WB_HierarchyPeriodRows, aRow=> aRow.isActive && aRow.cif.ACTIVE_IND=='1'))
    }

    getLevelById(levelId: string): WB_HierarchyLevelRow {
        if(_.isEmpty(levelId))
            return undefined

        let foundLevels = _.filter(this.WB_HierarchyRow.WB_HierarchyLevelRows, aRow=> (aRow.isActive && aRow.cif.LEVEL_ID == levelId))

        return _.first(foundLevels)

    }

    getLevelByWbHierarchyLevelId(wbHierLvlId: number): WB_HierarchyLevelRow {

        let foundLevels = _.filter(this.WB_HierarchyRow.WB_HierarchyLevelRows, aRow=> (aRow.isActive && aRow.cif.WB_HIERARCHYLR_ID == wbHierLvlId))

        return _.first(foundLevels)

    }


    get LeafLevel(): WB_HierarchyLevelRow {
        let harnessLevels = _.sortBy(
            _.filter(this.WB_HierarchyRow.WB_HierarchyLevelRows, (a) => a.isActive),
            (b) => b.cif.LEVEL_DEPTH)
        let leafLevel: WB_HierarchyLevelRow = undefined
        _.forEach(this.WB_HierarchyRow.WB_HierarchyLevelRows, (a) => {
            if(_.isEmpty(leafLevel))
                leafLevel = a
            if(leafLevel.cif.LEVEL_DEPTH < a.cif.LEVEL_DEPTH)
                leafLevel = a
        })
        return leafLevel
    }

    get WbSalesAreaIds(): number[] {
        return _.map(_.filter(this.WB_HierarchyRow.WB_HierarchySalesAreaRows,
            (a) => a.isActive),
            (b) => b.cif.WB_SALESAREA_ID)
    }

    get getAggregateNodeMapper(): string {
        switch (this._hierarchyRow.cif.ENTITY_DIMENSION){
            case "Customer":
                return esWB_Customer

            case "Product":
                return esWB_Product_Group

            case "Period":
                return esWB_Period

            case "UserGroup":
                return esWB_User_Group
        }

        return ""
    }

    async getDeletedNodesFromView(np: IHierarchyNodeProvider): Promise<INode[]>{
        if(_.isEmpty(np))
            return

        let rv: INode[] = []
        let arrDeletedNodes: IHierarchyDeleteNodesRow[] = await PASearch.find("vUI_Hierarchy_Deleted_Nodes",{
            WB_HIERARCHY_ID: this.WB_HierarchyRow.cif.WB_HIERARCHY_ID,
        },vUI_Hierarchy_DeleteNodes_schema,[],0,[])

        let rowsByMapper = _.groupBy(arrDeletedNodes, (a) => a.NODE_MAPPER);
        for(let mapperName in rowsByMapper){
            let rows = rowsByMapper[mapperName]
            let wbIds = _.map(rows, (a) => a.NODE_WB_ID)
            let dns = await np.findNodesByWbIds(mapperName, wbIds)
            _.forEach(dns, (a)=> rv.push(a));
        }

        return rv
    }

    getIntelligentKeySpec(wbEntityId: number): WB_HierarchyIntelligentKeyRow {
        if (!this._hierarchyRow || this._hierarchyRow.cif.HIERARCHY_WORKFLOW_MODE != "LandingZoneWithKey") {
            return undefined;
        }

        return _.first(_.filter(this._hierarchyRow.WB_HierarchyIntelligentKeyRows,
            (aRow: WB_HierarchyIntelligentKeyRow) => (aRow.cif.WB_ENTITY_ID == wbEntityId && aRow.isActive)));


    }

    getGeneratedEntityWbKeySetId(wbEntityId: number): number {

        let egRows = _.filter(this._hierarchyRow.WB_HierarchyEntityRows,
            (aRow: WB_HierarchyIntelligentKeyRow) => (aRow.cif.WB_ENTITY_ID == wbEntityId && aRow.isActive))

        let egRow = _.first(egRows)
        // @ts-ignore
        return (egRow?.cif?.WB_SET_ID || 0)
    }
    /**
    *
    * Using the given Parent Entity, parse its intelligent key to determine the substring that is the desired key. E.g., 7654321 is supplied key, parent's substring is 5,6 this will return "32"
    * */
    parseIntelligentKeyWbEntityId(wbEntityId: number, intelligentKey: string) : string {

        let intelligentKeyRow = this.getIntelligentKeySpec(wbEntityId)

        if (!intelligentKeyRow || intelligentKey.length <= intelligentKeyRow.cif.END_DIGIT) {
            //handle case of intelligent key row not existing or the supplied key being too short
            return undefined;
        }

        //the digits are 1-indexed
        return intelligentKey.substring(intelligentKeyRow.cif.START_DIGIT - 1, intelligentKeyRow.cif.END_DIGIT);

    }

    getWorkerCount(pWorkerCountDefault?: number): number {
        if(_.isEmpty(this.WB_HierarchyRow)){
            if(_.isNumber(pWorkerCountDefault))
                return pWorkerCountDefault

            return workerCountDefault
        }

        let wc = this.WB_HierarchyRow.cif.WORKER_COUNT
        if(wc == 0)
            wc = workerCountDefault
        return Math.min(Math.max(wc, workerCountMin), workerCountMax)
    }


    //use this method to load up the hierarchy
    static async findHarness(wbHierarchyId: number, options?: {dbContext?: PAdbContext}): Promise<HierarchyHarness> {
        let opts = options || {}
        let dbContext = opts.dbContext

        if(_.isEmpty(dbContext))
            dbContext = new PAdbContext()

        let rr = new ESRecordResolver(dbContext, {
            standardConditions: {
                [esWB_Hierarchy]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Hierarchy_Level]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Hierarchy_Period]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Hierarchy_SalesArea]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Hierarchy_Intelligent_Key]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Hierarchy_Entity_Generation]:{"DELETED_IND": {"notIn": ['1']}}
            },
            dctExcludeHasManyNamedRelations: {
            },
            dctIncludeBelongsToNamedRelations: {

            }
        })

       await rr.findAllWithRelationships(esWB_Hierarchy, [wbHierarchyId])
        let aRow: WB_HierarchyRow = <WB_HierarchyRow> rr.get(esWB_Hierarchy, wbHierarchyId)
        if(_.isEmpty(aRow) || !aRow.isActive)
            return undefined

        return new HierarchyHarness(aRow)
    }


}
